import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FlagContext } from '../../../flags/Flags';
import { withSession } from '../../../i18n/containers/AppInit.js';
import * as Util from '../../../common/utilities';

export class UploadCatalogHelper extends Component {
  handleFileSelect(session) {
    return event => {
      const file =
        event.target.files &&
        event.target.files.length &&
        event.target.files[0];
      if (file) {
        const payload = new FormData();
        payload.append('file', file, file.name);
        this.props.actions.createCatalog(payload, { cToken: session.cToken });
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (Util.propChanged(prevProps, this.props, 'catalogs.length')) {
      if (this.props.onUploadStart) {
        this.props.onUploadStart();
      }
    }
  }

  importAllowed(flags) {
    return !(flags && flags.isReadonly);
  }

  render() {
    return withSession(session => {
      return (
        <FlagContext.Consumer>
          {flags => (
            <input
              type="file"
              id="open-file-input"
              ref={this.props._ref}
              style={{ display: 'none' }}
              disabled={!this.importAllowed(flags)}
              onChange={this.handleFileSelect(session)}
              onClick={event => {
                event.target.value = null;
              }}
            />
          )}
        </FlagContext.Consumer>
      );
    });
  }
}

UploadCatalogHelper.propTypes = {
  actions: PropTypes.object,
  catalogs: PropTypes.array,
  onUploadStart: PropTypes.func,
  _ref: PropTypes.object
};

export default UploadCatalogHelper;
